import { render, staticRenderFns } from "./tranSaleOrders.vue?vue&type=template&id=aa003de2&scoped=true&"
import script from "./tranSaleOrders.vue?vue&type=script&lang=js&"
export * from "./tranSaleOrders.vue?vue&type=script&lang=js&"
import style0 from "./tranSaleOrders.vue?vue&type=style&index=0&id=aa003de2&lang=less&scoped=true&"
import style1 from "./tranSaleOrders.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa003de2",
  null
  
)

component.options.__file = "tranSaleOrders.vue"
export default component.exports